import React, { memo } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '../../../components/material-ui/Dialog';
import { TextField } from '../../../components/material-ui/TextField';
import { DialogControls } from '../../../components/DialogControls/DialogControls';
import { useStyles } from './useStyles';

export const ChooseAirportModal = memo((props) => {
    const { onOk, hideModal, open } = props;
    const [value, changeValue] = React.useState('');
    const classes = useStyles();
    const { t: translate } = useTranslation();
    const ref = React.useRef();
    const handleChange = React.useCallback((event) => {
        changeValue(event.target.value);
    }, []);

    const handleAdd = React.useCallback(() => {
        onOk(get(ref, 'current.value', ''));
        changeValue('');
        if (ref) {
            ref.current.value = '';
        }
    }, [ref]);

    const actionList = React.useMemo(
        () => [
            {
                label: translate('close'),
                onClick: hideModal,
            },
            {
                label: translate('getData'),
                color: 'primary',
                disabled: !get(ref, 'current.value', false),
                onClick: handleAdd,
            },
        ],
        [handleAdd, Boolean(get(ref, 'current.value', false))]
    );

    return (
        <Dialog open={open} style={{ zIndex: 1600 }}>
            <DialogTitle className={classes.title}>{translate('modal.requestNoticesModal')}</DialogTitle>
            <DialogContent className={classes.container}>
                <TextField
                    inputRef={ref}
                    fullWidth={true}
                    label={translate('modal.airportICAOCode')}
                    value={value}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions className={classes.controls}>
                <DialogControls actions={actionList} />
            </DialogActions>
        </Dialog>
    );
});
